<!-- <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" style="width: 100%; height: 400px;">  -->

<agm-map
  #AgmMap
  [ngStyle]="{ width: sideLength, height: sideLength }"
  (mapReady)="onMapReady($event)"
  [zoomControl]="true"
  [scrollwheel]="false"
  [streetViewControl]="false"
>
  <div *ngFor="let area of this.aree">
    <agm-data-layer
      [geoJson]="area.geomArea"
      [style]="styleFunc"
    ></agm-data-layer>
  </div>
</agm-map>
